/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CouponCodesHalResponse } from '../../models/coupon-codes-hal-response';

export interface CouponsCouponIdCodesGet$Params {
  'Active-Tenant-Identifier': string;
  couponId: string;
  count?: number;
  prefix?: string;
}

export function couponsCouponIdCodesGet(http: HttpClient, rootUrl: string, params: CouponsCouponIdCodesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponCodesHalResponse>> {
  const rb = new RequestBuilder(rootUrl, couponsCouponIdCodesGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('couponId', params.couponId, {});
    rb.query('count', params.count, {});
    rb.query('prefix', params.prefix, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CouponCodesHalResponse>;
    })
  );
}

couponsCouponIdCodesGet.PATH = '/coupons/{couponId}/codes';
